export function toLowerCaseInvariant(value: string): string {
	return value.toLocaleLowerCase('en');
}

export function toKebabCase(value: string): string {
	return toLowerCaseInvariant(value).replace(' ', '-');
}

export function roundNumberInputValue(value: string): string {
	const rounded = Math.round(Number.parseFloat(value));

	return isNaN(rounded) ? '' : rounded.toString();
}

export function getFileExtension(fileName: string): string {
	const dotIndex = fileName.lastIndexOf('.');

	if (dotIndex > 0 && dotIndex < fileName.length - 1) {
		return fileName.slice(dotIndex);
	}

	return '';
}
